import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import DriverInstantTripsGuide from '../features/landing/sections/DriverInstantTripsGuide';
import '../styles/landing.css';
import '../styles/how-it-works-driver.css';

const DriverInstantTripsGuidePage: React.FC = () => {
  return (
    <div className="landing-shell">
      <Header />
      <main>
        <section className="driver-how-guide-hero">
          <div className="container">
            <Link className="driver-how-back-link" to="/how-it-works">
              Back to guide hub
            </Link>
            <span className="sw-eyebrow">Driver App guide</span>
            <h1>Instant Trips</h1>
            <p>
              Use this guide when you are online and receive a trip that must start right away.
            </p>
          </div>
        </section>
        <DriverInstantTripsGuide />
      </main>
      <Footer />
    </div>
  );
};

export default DriverInstantTripsGuidePage;
